export default {
  "content": "<path fill=\"none\" d=\"M0 0h32v32H0z\"/><path d=\"M12 22a1.003 1.003 0 01-1-1V11a1 1 0 011.447-.895l10 5a1.001 1.001 0 010 1.79l-10 5c-.141.07-.294.105-.447.105z\" fill=\"#fff\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 32 32"
  }
};